import { MobileSearchField } from '@/features/mobile-ui';

import { InboxFilterButton } from './inbox-filter-button';

interface ConversationsInboxFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  platformFilter: string;
  onPlatformFilterChange: (value: string) => void;
}

/**
 * The search field with the filter button to its right — the same row on the
 * desktop list and the phone.
 */
export function ConversationsInboxFilters({
  search,
  onSearchChange,
  platformFilter,
  onPlatformFilterChange,
}: ConversationsInboxFiltersProps) {
  return (
    <div className="flex items-center gap-2">
      <MobileSearchField
        className="min-w-0 flex-1"
        value={search}
        onChange={onSearchChange}
        placeholder="Search conversations…"
      />
      <InboxFilterButton
        platform={platformFilter}
        onPlatformChange={onPlatformFilterChange}
      />
    </div>
  );
}
